import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { ScoreDetailComponent } from '@shared/score-detail/components/score-detail.component';
import { TagRatingDsComponent } from '@design-system/components/molecules/tag-rating/tag-rating.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@NgModule({
  declarations: [ScoreDetailComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    TagRatingDsComponent,
    DividerDsComponent,
  ],
  exports: [ScoreDetailComponent],
  providers: [],
})
export class ScoreDetailModule { }
